<template>
  <div>
    <!-- start -->
    <div class="topDiv">
      <div class="topTitle">从战略到落地,全程为您护航</div>
      <div class="bottomTitle marginTop43">数拓科技，为客户提供“咨询、方案、技术、实施、内容、运营”全周期服务。
                        </div>
      <!-- <div class="bottomTitle">我们的用心,换你们的不操心。</div> -->
    </div>
    <!-- end -->
    <div class="boxParentFu">
      <img v-lazy="bgImg" alt class="bgImgCss">
      <div class="boxParent">
        <div
          class="box"
          v-for="(item,index) in listArray"
          :style="{borderRight:(index == 2 || index == 5 ? '1px solid rgba(229, 229, 229, 1)':'0px')}"
        >
          <div class="num">{{item.num}}</div>
          <div class="boxTitle">{{item.title}}</div>
          <div class="boxText">{{item.text}}</div>
        </div>
        <div class="box" style="borderRight:1px solid rgba(229, 229, 229, 1)">
          <div class="num">06</div>
          <div class="boxTitle">7 <img v-lazy="changHao" alt="" style="width:18px;" srcset=""> 24客服</div>
          <div class="boxText">专业化客服团队，提供在线指导、问题解答、代运营等全套售后服务。重点项目，我们将配置专属客服，提供一对一精准服务。</div>
        </div>
      </div>
    </div>

    <!-- 典型客户案例 start -->
    <div class="anli">
      <div class="anliTitle">典型客户案例</div>
      <div class="lineCss"></div>
      <!-- 轮播 start -->
      <div class="swiper">
        <div class="swiper-container1">
          <div class="swiper-wrapper swiper-no-swiping" id="swiper-wrapperKeHu">
            <div class="swiper-slide" v-for="(value,index) in slideArray" @click="toPage(index)">
              <img :src="value" alt class="swiperImg" style="width:100%;max-width:413px;">
            </div>
            <!-- <div class="swiper-slide" @click="toPage('SuccessCases/CaseDetailWanDa')">
              <img :src="scrollImg2" alt class="swiperImg">
            </div>
            <div class="swiper-slide" @click="toPage('SuccessCases/SuccessCaseDetail')">
              <img :src="scrollImg1" alt class="swiperImg">
            </div>
            <div class="swiper-slide" @click="toPage('SuccessCases/teBuCase')">
              <img :src="scrollImg0" alt class="swiperImg">
            </div>-->
            <!-- <div class="swiper-slide" @click="toPage('SuccessCases/caseTaihe')">
              <img :src="scrollImg3" alt class="swiperImg">
            </div>
            <div class="swiper-slide" @click="toPage('SuccessCases/caseGxg')">
              <img :src="scrollImg4" alt class="swiperImg">
            </div>
            <div class="swiper-slide" @click="toPage('SuccessCases/caseNorthFace')">
              <img :src="scrollImg5" alt class="swiperImg">
            </div>-->

            <!-- 加载更多 start -->
            <!-- <div v-show="isShowMore" class="swiper-slide" @click="toPage('SuccessCases/CaseDetailWanDa')">
              <img :src="scrollImg3" alt class="swiperImg" >
              <img :src="wanDaLogo" alt class="positionLogo">
            </div>
            <div  v-show="isShowMore" class="swiper-slide" @click="toPage('SuccessCases/SuccessCaseDetail')">
              <img :src="scrollImg4" alt class="swiperImg">
              <img :src="haiDiLaoLogo" alt class="positionLogo">
            </div>
            <div  v-show="isShowMore" class="swiper-slide" @click="toPage('SuccessCases/teBuCase')">
              <img :src="scrollImg5" alt class="swiperImg">
              <img :src="teBuLogo" alt class="positionLogo">
            </div>-->
            <!-- 加载更多 end-->

            <div v-show="!isShowMore" class="swiper-slide" @click="showSwiper">
              <!-- <div class="swiper-slide" @click="showSwiper"> -->
              <img :src="scrollImg6" alt class="swiperImg">
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-pagination1"></div>
        </div>
      </div>
      <!-- 轮播 end -->

      <div></div>
      <!-- 左边的灰块 start -->
      <div class="grayBox"></div>
      <!-- 左边的灰块 end -->
    </div>
    <!-- 典型客户案例 end -->
    <!-- 更多客户 start -->

    <div class="keHu">
      <div class="anliTitle">更多客户</div>
      <div class="lineCss"></div>
    </div>
    <!-- 
    <div class="keHuFlex">
      <div
        class="keHuBox"
        v-for="(item , index) in logoArray "
        v-on:mouseover="changeActive(index)"
        v-on:mouseout="removeActive(index)"
        :style="{borderRight:(index == 4 || index == 9 ? '1px solid rgba(179, 179, 179, 1)':'0px'),borderBottom:(index == 0 || index == 1 || index == 2 || index == 3 || index == 4? '0px':'1px solid rgba(179, 179, 179, 1)')}"
      >
        <div>
          <transition name="fade">
            <img :src="item" alt>
          </transition>
        </div>
      </div>
    </div>-->
    <!-- 更多客户 end -->
    <!-- 更多客户轮播 start -->
    <div class="keHuSwiper">
      <div class="swiper-containerKeHu">
        <div class="swiper-wrapper swiper-no-swiping">
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper1" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper2" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper3" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper4" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper5" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper6" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper7" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper8" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper9" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper10" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper11" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper12" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper13" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper14" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper15" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper16" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper17" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper18" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper19" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper20" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper21" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper22" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper23" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper24" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper25" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper26" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper33" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper34" alt srcset>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="keHuSwiperFlex">
              <div class="swiperBox">
                <img :src="keHuSwiper27" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper28" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper29" alt srcset>
              </div>
              <div class="swiperBox">
                <img :src="keHuSwiper30" alt srcset>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 更多客户轮播 end -->
  </div>
</template>
<script>
import bgImg from "@/assets/images/zhanlue-bg.png";
import haiDiLao from "@/assets/images/haidilao-bg.png";
import teBuLogo from "@/assets/images/teBuLogo.png";
import haiDiLaoLogo from "@/assets/images/haidilao-LOGO.png";
import wanDaLogo from "@/assets/images/wanda-LOGO.png";
import scrollImg0 from "@/assets/images/scrollImg0.png";
import scrollImg1 from "@/assets/images/scrollImg1.png";
import scrollImg2 from "@/assets/images/scrollImg2.png";
import scrollImg3 from "@/assets/images/scrollImg3.png";
import scrollImg4 from "@/assets/images/scrollImg4.png";
import scrollImg5 from "@/assets/images/scrollImg5.png";
import scrollImg6 from "@/assets/images/scrollImg6.png";
import swiperToRight from "@/assets/images/swiperToRightIcon.png";
import swiperToLeft from "@/assets/images/swiperToLeftIcon.png";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
// 客户swiper start
import keHuSwiper1 from "@/assets/images/keHuSwiper1.png";
import keHuSwiper2 from "@/assets/images/keHuSwiper2.png";
import keHuSwiper3 from "@/assets/images/keHuSwiper3.png";
import keHuSwiper4 from "@/assets/images/keHuSwiper4.png";

import keHuSwiper5 from "@/assets/images/keHuSwiper5.png";
import keHuSwiper6 from "@/assets/images/keHuSwiper6.png";
import keHuSwiper7 from "@/assets/images/keHuSwiper7.png";
import keHuSwiper8 from "@/assets/images/keHuSwiper8.png";

import keHuSwiper9 from "@/assets/images/keHuSwiper9.png";
import keHuSwiper10 from "@/assets/images/keHuSwiper10.png";
import keHuSwiper11 from "@/assets/images/keHuSwiper11.png";
import keHuSwiper12 from "@/assets/images/keHuSwiper12.png";

import keHuSwiper13 from "@/assets/images/keHuSwiper13.png";
import keHuSwiper14 from "@/assets/images/keHuSwiper14.png";
import keHuSwiper15 from "@/assets/images/keHuSwiper15.png";
import keHuSwiper16 from "@/assets/images/keHuSwiper16.png";

import keHuSwiper17 from "@/assets/images/keHuSwiper17.png";
import keHuSwiper18 from "@/assets/images/keHuSwiper18.png";
import keHuSwiper19 from "@/assets/images/keHuSwiper19.png";
import keHuSwiper20 from "@/assets/images/keHuSwiper20.png";

import keHuSwiper21 from "@/assets/images/keHuSwiper21.png";
import keHuSwiper22 from "@/assets/images/keHuSwiper22.png";
import keHuSwiper23 from "@/assets/images/keHuSwiper23.png";
import keHuSwiper24 from "@/assets/images/keHuSwiper24.png";

import keHuSwiper25 from "@/assets/images/keHuSwiper25.png";
import keHuSwiper26 from "@/assets/images/keHuSwiper26.png";
import keHuSwiper27 from "@/assets/images/keHuSwiper27.png";
import keHuSwiper28 from "@/assets/images/keHuSwiper28.png";

import keHuSwiper29 from "@/assets/images/keHuSwiper29.png";
import keHuSwiper30 from "@/assets/images/keHuSwiper30.png";
import keHuSwiper31 from "@/assets/images/keHuSwiper31.png";
import keHuSwiper32 from "@/assets/images/keHuSwiper32.png";

import keHuSwiper33 from "@/assets/images/keHuSwiper33.png";
import keHuSwiper34 from "@/assets/images/keHuSwiper34.png";
import { constants } from "zlib";
import changHao from "@/assets/images/changHao.png";
import { domClick } from "../store/storeData";
import { setTimeout } from "timers";
// 客户swiper end
export default {
  name: "ContentBottom",
  data() {
    return {
      isShowMore: false,
      slideArray: [
        require("@/assets/images/scrollImg0.png"),
        require("@/assets/images/scrollImg1.png"),
        require("@/assets/images/scrollImg2.png")
      ],
      changHao: changHao,
      teBuLogo: teBuLogo,
      swiperToLeft: swiperToLeft,
      swiperToRight: swiperToRight,
      scrollImg0: scrollImg0,
      scrollImg1: scrollImg1,
      scrollImg2: scrollImg2,
      scrollImg3: scrollImg3,
      scrollImg4: scrollImg4,
      scrollImg5: scrollImg5,
      scrollImg6: scrollImg6,
      bgImg: bgImg,
      haiDiLao: haiDiLao,
      haiDiLaoLogo: haiDiLaoLogo,
      wanDaLogo: wanDaLogo,
      keHuSwiper1: keHuSwiper1,
      keHuSwiper2: keHuSwiper2,
      keHuSwiper3: keHuSwiper3,
      keHuSwiper4: keHuSwiper4,

      keHuSwiper5: keHuSwiper5,
      keHuSwiper6: keHuSwiper6,
      keHuSwiper7: keHuSwiper7,
      keHuSwiper8: keHuSwiper8,

      keHuSwiper9: keHuSwiper9,
      keHuSwiper10: keHuSwiper10,
      keHuSwiper11: keHuSwiper11,
      keHuSwiper12: keHuSwiper12,

      keHuSwiper13: keHuSwiper13,
      keHuSwiper14: keHuSwiper14,
      keHuSwiper15: keHuSwiper15,
      keHuSwiper16: keHuSwiper16,

      keHuSwiper17: keHuSwiper17,
      keHuSwiper18: keHuSwiper18,
      keHuSwiper19: keHuSwiper19,
      keHuSwiper20: keHuSwiper20,

      keHuSwiper21: keHuSwiper21,
      keHuSwiper22: keHuSwiper22,
      keHuSwiper23: keHuSwiper23,
      keHuSwiper24: keHuSwiper24,

      keHuSwiper25: keHuSwiper25,
      keHuSwiper26: keHuSwiper26,
      keHuSwiper27: keHuSwiper27,
      keHuSwiper28: keHuSwiper28,

      keHuSwiper29: keHuSwiper29,
      keHuSwiper30: keHuSwiper30,
      keHuSwiper31: keHuSwiper31,
      keHuSwiper32: keHuSwiper32,

      keHuSwiper33: keHuSwiper33,
      keHuSwiper34: keHuSwiper34,
      listArray: [
        {
          num: "01",
          title: "咨询服务",
          text:
            "兼顾行业背景和品牌调性，我们将配备经验丰富的售前咨询专家，提供更贴合需求的改造及升级建议。"
        },
        {
          num: "02",
          title: "方案定制",
          text:
            "策划不是天马行空的畅想。数拓要做的是融合品牌业务现状，将你的愿景变成可落地的方案。"
        },
        {
          num: "03",
          title: "技术开发",
          text:
            "数拓智屏OS历经多年市场验证，更加成熟稳定。我们将基于此架构，针对品牌的个性化需求，实现功能的快速开发及落地，让品牌营销紧跟潮流热点"
        },
        {
          num: "04",
          title: "内容创意",
          text:
            "内容团队，一群创意迸发的潮人聚集在此。根据品牌的调性，结合时下热门的设计风格，打造极具吸引力的视觉效果，将视觉特效与交互技术融合，帮助品牌提升用户体验"
        },
        {
          num: "05",
          title: "实施运维",
          text:
            "根据项目的体量层级，配置不同规模的实施团队。以专业化的服务理念，提供管家式服务。体贴细心的倾听客户的反馈，提供最及时专业的服务，保障项目的稳定实施。"
        }
        // {
        //   num: "06",
        //   title: "7✖24客服",
        //   text:
        //     "专业化客服团队，提供在线指导、问题解答、代运营等全套售后服务。重点项目，我们将配置专属客服，提供一对一精准服务。"
        // }
      ],
      logoArray: [
        require("@/assets/images/LOGO6.png"),
        require("@/assets/images/LOGO10.png"),
        require("@/assets/images/LOGO5.png"),
        require("@/assets/images/LOGO7.png"),
        require("@/assets/images/LOGO8.png"),
        require("@/assets/images/LOGO2.png"),
        require("@/assets/images/LOGO9.png"),
        require("@/assets/images/LOGO1.png"),
        require("@/assets/images/LOGO3.png"),
        require("@/assets/images/LOGO11.png")
      ],
      hoverImgArray: [
        require("@/assets/images/hoverImg1.png"),
        require("@/assets/images/hoverImg2.png"),
        require("@/assets/images/hoverImg3.png"),
        require("@/assets/images/hoverImg4.png"),
        require("@/assets/images/hoverImg5.png"),
        require("@/assets/images/hoverImg6.png"),
        require("@/assets/images/hoverImg7.png"),
        require("@/assets/images/hoverImg8.png"),
        require("@/assets/images/hoverImg9.png"),
        require("@/assets/images/hoverImg10.png")
      ],
      swiper: "",
      swiperKeHu: ""
    };
  },
  mounted() {
    this.swiper = new Swiper(".swiper-container1", {
      slidesPerView: 3.5,
      spaceBetween: 12,
      pagination: ".swiper-pagination1",
      clickable: true,
      prevButton: ".swiper-button-prev",
      nextButton: ".swiper-button-next"
    });
    this.swiperKeHu = new Swiper(".swiper-containerKeHu", {
      slidesPerView: 3,
      autoplayDisableOnInteraction: false,
      freeMode: true,
      autoplay: {
        delay: 0
      },
      loop: true, //循环
      speed: 4000
    });
  },
  methods: {
    showSwiper() {
      this.slideArray = [
        require("@/assets/images/scrollImg0.png"),
        require("@/assets/images/scrollImg1.png"),
        require("@/assets/images/scrollImg2.png"),
        
        require("@/assets/images/scrollImg4.png"),
        require("@/assets/images/scrollImg5.png")
      ];
      let tempImg = [require("@/assets/images/scrollImg5.png")];
      this.isShowMore = true;
      var str = "";
      var img_url = tempImg[0];
      for (var i = 0; i < 2; i++) {
        str +=
          "<a href='http://www.shutuo.tv/#/SuccessCases/caseNorthFace'><div class='swiper-slide' id='dongDom onclick='alert('点击了')'><img src='" +
          img_url +
          "'class='swiperImg'style='width:100%;max-width:413px;/></div></a>";
      }
      $("#swiper-wrapperKeHu").append(str);

      this.swiper = new Swiper(".swiper-container1", {
        slidesPerView: 3.5,
        spaceBetween: 12,
        pagination: ".swiper-pagination1",
        clickable: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next"
      });
      let _this = this
      setTimeout(function() {
        _this.swiper.slideTo(5, 1000);
      }, 100);
    },

    toPage(val) {
      let ValUrl;
      if (val == 0) {
        ValUrl = "SuccessCases/teBuCase";
      } else if (val == 1) {
        ValUrl = "SuccessCases/CaseDetailWanDa";
      } else if (val == 2) {
        ValUrl = "SuccessCases/SuccessCaseDetail";
      } else if (val == 3) {
        ValUrl = "SuccessCases/caseGxg";
      } else if (val == 4) {
        ValUrl = "SuccessCases/caseNorthFace";
      } else if (val == 5) {
        
      }
      let routeUrl = this.$router.resolve({
        path: `${ValUrl}`
      });
      window.open(routeUrl.href, "_blank");
    },
    swiperRight() {
      console.log(this.swiper);
      this.swiper.onSlideNextStart(this.swiper);
    },
    changeActive(index) {
      this.logoArray.splice(index, 1, this.hoverImgArray[index]);
    },
    removeActive(index) {
      this.logoArray = [
        require("@/assets/images/LOGO6.png"),
        require("@/assets/images/LOGO10.png"),
        require("@/assets/images/LOGO5.png"),
        require("@/assets/images/LOGO7.png"),
        require("@/assets/images/LOGO8.png"),
        require("@/assets/images/LOGO2.png"),
        require("@/assets/images/LOGO9.png"),
        require("@/assets/images/LOGO1.png"),
        require("@/assets/images/LOGO3.png"),
        require("@/assets/images/LOGO11.png")
      ];
    }
  }
};
</script>
<style scoped>
.swiper-button-next {
  background-image: url("../assets/images/swiperToRightIcon.png");
}
.swiper-button-prev {
  background-image: url("../assets/images/swiperToLeftIcon.png");
}
.topDiv {
  background: rgba(255, 255, 255, 1);
  text-align: center;
  margin-bottom: 90px;
}

.topTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin-top: 90px;
}

.bottomTitle {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 34px;
}

.marginTop43 {
  margin-top: 43px;
}

.bgImgCss {
  width: 100%;
}

.boxParentFu {
  position: relative;
  height: 1150px;
}

.boxParent {
  width: 1204px;
  position: absolute;
  top: 200px;
  background: #fff;
  left: calc(50% - 601px);
  display: flex;
  flex-wrap: wrap;
}

.box {
  width: 400px;
  height: 400px;

  border: 1px solid rgba(229, 229, 229, 1);
  border-top: 0px solid rgba(229, 229, 229, 1);
  border-right: 0px solid rgba(229, 229, 229, 1);

  transition: 0.7s;
}

.box:hover {
  box-shadow: 0px 3px 27px 0px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(252, 200, 0, 1);
}

.num {
  font-size: 5rem;
  font-family: STSongti-SC-Black;
  font-weight: 900;
  color: rgba(0, 0, 0, 1);
  padding-top: 35px;
  margin-right: 45px;
  transition: 0.7s;
}

.boxTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin-top: 40px;
}

.boxText {
  font-size: 1.9rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(92, 92, 92, 1);
  line-height: 30px;
  width: 81%;
  margin-top: 40px;
}

.num,
.boxTitle,
.boxText {
  margin-left: 35px;
}

.anli {
  text-align: center;
  position: relative;
  height: 790px;
}

.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.grayBox {
  width: 37%;
  height: 550px;
  background: rgba(240, 240, 240, 1);
  position: absolute;
  z-index: 0;
  right: 0;
  top: 100px;
}

.swiper-container {
  width: 1280px;
  height: 500px;
}

.swiper-slide {
  margin-left: 12px;
  position: relative;
}
.swiperImg {
  width: 100%;
  max-width: 413px;
}

.swiper-container1 {
  overflow: hidden;
  margin: auto;
}

.swiper {
  margin-top: 128px;
}

.moreCss {
  font-size: 3.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  height: 20px;
}

.positionLogo {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.keHu {
  text-align: center;
  margin-bottom: 100px;
}

.keHuFlex {
  width: 1200px;
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  margin-top: 71px;
}

.keHuBox {
  width: 238px;
  height: 240px;
  position: relative;
  border: 1px solid rgba(179, 179, 179, 1);
  opacity: 0.8;
}

.keHuBox img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.keHuBox:hover {
  background: #fcc800;
  opacity: 1;
}

.keHuFlex {
  transition: 0.3s;
}

.scrollParent {
  overflow: scroll;
  width: 1280px;
  margin: auto;
  margin-top: 86px;
}

.scrollDiv {
  width: 2036px;
  overflow: scroll;
  display: flex;
  justify-content: space-around;
}

.scrollBox {
  height: 500px;
  width: 25%;
}

.scrollBoxStyle {
  background: rgba(252, 200, 0, 1);
  font-size: 3.4rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 500px;
}

.inner-container::-webkit-scrollbar {
  display: none;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
@media screen and (max-width: 1200px) {
  .boxParent {
    width: 905px;
    left: calc(50% - 450px);
    top: 100px;
  }
  .boxParentFu {
    height: 825px;
  }

  .boxTitle {
    margin-top: 15px;
  }
  .box {
    width: 300px;
    height: 300px;
  }
  .keHuFlex {
    width: 909px;
  }
  .keHuBox {
    width: 180px;
    height: 182px;
  }
  .boxText {
    margin-top: 19px;
  }

  .grayBox {
    height: 420px;
    top: 128px;
  }
  .anli {
    height: 650px;
  }
}
.swiper {
  width: 70%;
  margin: auto;
  margin-top: 128px;
  min-width: 810px;
}
/* 客户swiper start */
.keHuSwiperFlex {
  display: flex;
  flex-wrap: wrap;
}
.swiperBox {
  display: inline-block !important;
  border: 1px solid #ddd;
  border-bottom: 0;
  border-right: 0;
  width: 50%;
  box-sizing: border-box;
  text-align: center;
  opacity: 0.9;
}
.keHuSwiper {
  width: 70%;
  border: 1px solid #ddd;
  border-top: 0;
  margin: auto;
}
.swiper-containerKeHu {
  overflow: hidden;
}
.swiperBox img {
  width: 75%;
  max-width: 180px;
}
.swiper-slide {
  margin-left: 0;
}

/* 客户swiper end */
</style>



// WEBPACK FOOTER //
// src/components/ContentBottom.vue